<script>
    export let title;
    export let text;
    export let url;
    export let width;
    export let height;
    export let software;
    export let link;
</script>

<a class="link-container" href={link} target="_blank">
    <div class="card-container">
        <img class="heroimage" width={width} height={height} src={url} alt="logo">
        <div class="info">
            <p class="text title">{title}</p>
            <p class="text body">{text}</p>
        </div>
        <span class="software">{software}</span>
    </div>
</a>


<style>
    .software {
        background-color: hsl(278deg 99% 50%);
        border-radius: 20px;
        height: 20px;
        padding: 2px;
        padding-left: 8px;
        padding-right: 8px;
        font-size: 12px;
        line-height: 20px;
        position: absolute;
        top: 1rem;
        right: 1rem;
    }
    .info {
        flex:1;
        padding:1rem;
    }
    .text {
        text-align: left;
        margin-top:1rem;
    }

    .body {
        font-size:16px;
    }

    .title {
        font-size: 24px;
        font-weight:bolder;
        margin-bottom:1rem;
    }

    .card-container {
        width:85%;
        border-radius: 8px;
        margin:auto;
        box-shadow: 0px 3px 15px rgba(0,0,0,0.2);
        background-color: white;
        /* padding-top:1rem;
        padding-bottom:1rem; */
        margin-top:3rem;
        text-align: center;
        color:#ebebeb;
        background-color:#111;
        display:flex;
        flex-direction: column;
        position:relative;
        cursor: pointer;
    }

    .card-container:hover {
        box-shadow: 0px 3px 15px hsl(278deg 99% 50%);
    }

    .card-container:focus {
        box-shadow: 0px 3px 15px hsl(278deg 99% 50%);
    }

    .heroimage {
        width:100%;
        min-width: 50px;
        display:block;
        margin:0;
        /* padding-top:24px;
        padding-bottom:24px; */
        max-width:600px;
        height:auto;
        border-radius: 8px 8px 0 0px;
    }

    /* .card-container:nth-child(2) {
        margin-top:4rem;
    } */

    .link-container:nth-child(2) {
        margin-top:4rem;
        display:block;
    }

    .link-container:last-child {
        margin-bottom:8rem;
        display:block;
    }

    @media (min-width: 640px) {
		.card-container {
           max-width: 800px;
           flex-direction: row;
        }
        .heroimage {
            width:25%;
            min-width: 250px;
            border-radius: 8px 0 0 8px;
        }

        .title {
            font-size: 24px;

        }
        .body {
            font-size: 24px;
            font-size: 16px;
        }
	}
</style>